import api from './client';

export type ShellFormat = 'text' | 'json';

export interface ShellResponse {
  ok?: boolean;
  [key: string]: unknown;
}

/** Execute a shell command and return raw text (default) or JSON string. */
export async function executeShellCommand(commandLine: string, format: ShellFormat = 'text'): Promise<string> {
  const accept = format === 'json' ? 'application/json' : 'text/plain';
  const { data } = await api.post('/api/admin/shell/execute', { commandLine }, {
    headers: { Accept: accept },
    transformResponse: [(raw: string) => raw],
  });
  return data;
}

/** Execute a shell command and return parsed JSON. Used by inspector panels. */
export async function executeShellCommandJson(commandLine: string): Promise<ShellResponse> {
  const { data } = await api.post<ShellResponse>('/api/admin/shell/execute', { commandLine }, {
    headers: { Accept: 'application/json' },
  });
  return data;
}

export async function listShellCommands(): Promise<string[]> {
  const { data } = await api.get<{ commands: string[] }>('/api/admin/shell/commands', {
    headers: { Accept: 'application/json' },
  });
  return data.commands;
}
